export default {"src":"/_next/static/media/doc_big_icon.eb6f99de.svg","height":52,"width":53,"blurWidth":0,"blurHeight":0};